import {
  GET_MEASUREMENTS_FAILED,
  GET_MEASUREMENTS_PENDING,
  GET_MEASUREMENTS_SUCCESS,
} from '../actionTypes'

import { getMeasurementsService } from '../../service/measurements.service'

export const getMeasurementsPending = () => ({
  type: GET_MEASUREMENTS_PENDING,
})

export const getMeasurementsSuccess = (value) => ({
  type: GET_MEASUREMENTS_SUCCESS,
  payload: value,
})

export const getMeasurementsFailed = (error) => ({
  type: GET_MEASUREMENTS_FAILED,
  payload: error,
})

export const getMeasurementsAction = (pointId) => async (dispatch) => {
  try {
    dispatch(getMeasurementsPending())
    const measurements = await getMeasurementsService(pointId)
    if (measurements) {
      dispatch(getMeasurementsSuccess(measurements))
    }
  } catch (error) {
    dispatch(getMeasurementsFailed(error))
  }
}
